export const NOTIFICATIONS_POLLING_INTERVAL = 45_000;

export const NOTIFICATION_STATUSES = {
  INFO: 100000000,
  SUCCESS: 100000001,
  WARNING: 100000002,
  ERROR: 100000003
} as const;

export type NotificationStatus = (typeof NOTIFICATION_STATUSES)[keyof typeof NOTIFICATION_STATUSES];
